export default "__VITE_ASSET__D6J0avsz__";